// extracted by mini-css-extract-plugin
module.exports = {"snackbarMessage":"styles_snackbarMessage__jNO5o","sectionName":"styles_sectionName__3Oal8","smallMobile":"styles_smallMobile__DTRIz","snackbarIcon":"styles_snackbarIcon__2hBAs"};